export const SPINNER_SIZES = ['default', 'sm', 'md'] as const

export type SpinnerSize = (typeof SPINNER_SIZES)[number]

export interface SpinnerProps {
  size?: SpinnerSize
}
